import { useSelector } from 'react-redux';
import { ExpandableList, IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { hasPlatformScopeWithAccessAllEnterprises } from '@mews-commander/legacy-entities/src/ducks/scopes';
import {
    isCurrentProfileAdmin,
    hasCurrentProfilePlatformScope,
    canCurrentProfileConfigureEnterprise,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';
import { CommonMenuItems } from './MenuItems';

export const AccessControlMenu = () => {
    const canConfigureEnterprise: boolean = useSelector(canCurrentProfileConfigureEnterprise);
    const isAdmin: boolean = useSelector(isCurrentProfileAdmin);
    const canAccessAllEnterprises: boolean = useSelector(hasPlatformScopeWithAccessAllEnterprises);
    const hasPlatformScope: boolean = useSelector(hasCurrentProfilePlatformScope);

    return (
        <>
            {canConfigureEnterprise || (hasPlatformScope && canAccessAllEnterprises) || isAdmin ? (
                <>
                    <ExpandableList>
                        <SidebarExpandableListItem
                            leftIcon={<SidebarFontIcon value={IconName.Employees} />}
                            primaryText={<LocalizedText textKey={TextKey.UsersAndRoles} />}
                            value="usersAndRoles"
                        >
                            {createListItemWithLink({
                                textKey: TextKey.Roles,
                                iconName: IconName.Staff,
                                path: 'Roles/Index',
                                tooltip: null,
                                isMainItem: true,
                            })}

                            {createListItemWithLink({
                                textKey: TextKey.UserGroups,
                                iconName: IconName.ReservationGroup,
                                path: 'UserGroups/Index',
                                tooltip: null,
                                isMainItem: true,
                            })}
                        </SidebarExpandableListItem>
                    </ExpandableList>

                    {createListItemWithLink({
                        textKey: TextKey.Security,
                        iconName: IconName.Security,
                        path: 'Security/Index',
                        tooltip: null,
                        isMainItem: true,
                    })}
                </>
            ) : null}
            <CommonMenuItems />
        </>
    );
};
